import { defineMessages } from "react-intl"
import { ColumnDefinition, ColumnDefinitionCategory, DataType } from "."
import { ObjectType, ObjectTypeConfig } from ".."
import ItemReportOrdersButton from "../../../../order/ItemReportOrdersButton"
import { PREFERENCE_TYPE } from "../../constants"

export enum ItemReportColumnIds {
    TITLE = "productTitle",
    SKU = "productSku",
    DEFAULT_VENDOR = "productDefaultVendor",
    TOTAL_ON_ORDER = "totalOnOrder",
    RESERVED = "inventoryReserved",
    REQUESTED_WITH_PO = "requestedWithPo",
    REQUESTED_WITHOUT_PO = "inventoryRequested",
    INVOICED = "invoicedMeasure",
    INCLUDED_IN_ORDERS = "includedInOrders",
}

const columnDefinitions: ColumnDefinition[] = [
    {
        id: ItemReportColumnIds.TITLE,
        sortId: "productTitle",
        defaultSort: true,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT, ColumnDefinitionCategory.PRODUCT_RELATED],
    },
    {
        id: ItemReportColumnIds.SKU,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT, ColumnDefinitionCategory.PRODUCT_RELATED],
    },
    {
        id: ItemReportColumnIds.DEFAULT_VENDOR,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT, ColumnDefinitionCategory.PRODUCT_RELATED],
    },
    {
        id: ItemReportColumnIds.TOTAL_ON_ORDER,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: ItemReportColumnIds.RESERVED,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: ItemReportColumnIds.REQUESTED_WITH_PO,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: ItemReportColumnIds.REQUESTED_WITHOUT_PO,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },    
    {
        id: ItemReportColumnIds.INVOICED,
        dataType: DataType.STRING,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: ItemReportColumnIds.INCLUDED_IN_ORDERS,
        dataType: DataType.COMPONENT,
        dataAttributes: {
            component: ItemReportOrdersButton,
            props: {
                data: "original", //is the full row content
                filters: "filters" //is the listing filters type FiltersState
            }
        },
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
]

const headerMessages = defineMessages({
    [ItemReportColumnIds.TITLE]: {
        id: "generic-listing.item-report.title",
        defaultMessage: "Title",
    },
    [ItemReportColumnIds.SKU]: {
        id: "generic-listing.item-report.sku",
        defaultMessage: "Sku",
    },
    [ItemReportColumnIds.DEFAULT_VENDOR]: {
        id: "generic-listing.item-report.default-vendor",
        defaultMessage: "Vendor",
    },
    [ItemReportColumnIds.TOTAL_ON_ORDER]: {
        id: "generic-listing.item-report.total-on-order",
        defaultMessage: "Total on order",
    },
    [ItemReportColumnIds.RESERVED]: {
        id: "generic-listing.item-report.reserved",
        defaultMessage: "Reserved from inventory",
    },
    [ItemReportColumnIds.REQUESTED_WITH_PO]: {
        id: "generic-listing.item-report.requested-with-po",
        defaultMessage: "Requested on PO",
    },
    [ItemReportColumnIds.REQUESTED_WITHOUT_PO]: {
        id: "generic-listing.item-report.requested-without-po",
        defaultMessage: "Requested without PO",
    },
    [ItemReportColumnIds.INVOICED]: {
        id: "generic-listing.item-report.invoiced",
        defaultMessage: "Invoiced",
    },
    [ItemReportColumnIds.INCLUDED_IN_ORDERS]: {
        id: "generic-listing.item-report.included-in-orders",
        defaultMessage: "Included in orders",
    },
})

const configuration: ObjectTypeConfig = {
    objectType: ObjectType.ITEM_REPORT,
    columnDefinitions,
    headerMessages,
    listingPreferencesKey: PREFERENCE_TYPE.LISTING_ITEM_REPORTS,
    searchPlaceholder: {
        id: "generic-listing.item-report.search-placeholder",
        defaultMessage: "Search for a product...",
    },
    displayString: {
        id: "generic-listing.item-report.display-string",
        defaultMessage: "Item Report",
    },
    searchObjectType: ObjectType.ORDER_LINES,
    bulkActionDefinitions: [],
}

export default configuration


// WEBPACK FOOTER //
// ./src/state/listing/generic-listing/column-definitions/itemReportList.ts